module.exports = __webpack_public_path__ + "02_bob_yellow.218e54c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_bob_yellow.png
// module id = m4Nq
// module chunks = 0